import * as Sentry from '@sentry/browser';

import type { ErrorContext } from '../types';
import { ddErrorLogger } from '../ddLogger';
import { shouldIgnoreCapturedError } from './shouldIgnoreCapturedError';

export const captureException = (
  error: Error,
  errorContext: ErrorContext,
  ignoredErrors: (RegExp | string)[] = [],
): void => {
  const { domain, squadName, featureName, featureCriticality } = errorContext.tags;

  const tags = {
    squad: squadName ?? 'hotjar',
    featureCriticality: featureCriticality ?? 'unknown',
    featureName,
    domain,
  };

  // eslint-disable-next-line no-console
  console.error(error);
  // eslint-disable-next-line no-console
  console.info(errorContext);

  if (shouldIgnoreCapturedError(error, ignoredErrors)) return;

  Sentry.captureException(error, {
    tags,
    extra: errorContext.extra,
  });

  const errorName = error?.message ?? error?.name ?? 'error';
  ddErrorLogger?.error(errorName, {
    team: tags.squad,
    featureCriticality: tags.featureCriticality,
    domain: tags.domain,
    // We don't pass featureName tags because the cardinality would be too big
  });
};
